/// <reference path='../interfaces/interfaces.d.ts' />

'use strict';

angular.module('schemaForm');

import './directives/schematimepicker.directive';
import './directives/employee_select.directive';
import './directives/file_select.directive';
import './directives/org_prop_select.directive';
import './directives/datepicker_schema.directive';


import './configs/default_v1.config';
import './configs/checkbox_v1.config';
import './configs/select_v1.config';
import './configs/number_v1.config';
import './configs/employee_select.config';
import './configs/timepicker.config';
import './configs/file_select.config';
import './configs/org_prop.config';
import './configs/date_fields.config';

import './controllers/daypicker.controller.ts'



// WEBPACK FOOTER //
// ./frontend/scripts/schemaForm/_module.ts